import React, { useState } from 'react';
import PropTypes from 'prop-types';

import DrawerContainer from './DrawerContainer';
import Sidebar from './Sidebar';

function AppControls({
    availableIndexes,
    currentMatrix,
    currentMatrixId,
    matrixFiles,
    growthPeriod,
    zoom,
    handleSelectMatrix,
    handleSelectInflation,
    handleSelectTimeframe,
    handleShowReturns,
    handleZoom,
    handleTimeframeSubmit
}) {
    const { meta: { name: currentMatrixName }} = currentMatrix;
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [tabIndex, setTabIndex] = useState(0);
    const handleToggleDrawer = (showDrawer, tabIndex=0) => {
        setIsDrawerOpen(showDrawer);
        setTabIndex(tabIndex);
    }
    const handleSelectTabIndex = (tabIndex) => setTabIndex(tabIndex);
    const handleShowMetrics = () => handleToggleDrawer(true, 0); // opens drawer with first tab
    const handleShowComparisons = () => handleToggleDrawer(true, 1); // opens drawer with second tab
    const handleDrawerInteraction = () => handleToggleDrawer(!isDrawerOpen, tabIndex);
    return (
        <React.Fragment>
            <div id="sidebar">
                <Sidebar
                    currentMatrix={currentMatrix}
                    currentMatrixId={currentMatrixId}
                    currentMatrixName={currentMatrixName}
                    matrixFiles={matrixFiles}
                    zoom={zoom}
                    growthPeriod={growthPeriod}
                    handleSelectMatrix={handleSelectMatrix}
                    handleSelectInflation={handleSelectInflation}
                    handleShowReturns={handleShowReturns}
                    handleSelectTimeframe={handleSelectTimeframe}
                    handleZoom={handleZoom}
                    handleShowMetrics={handleShowMetrics}
                    handleShowComparisons={handleShowComparisons}
                    handleTimeframeSubmit={handleTimeframeSubmit}
                />
            </div>
            <DrawerContainer
                availableIndexes={availableIndexes}
                showDrawer={isDrawerOpen}
                handleToggleDrawer={handleDrawerInteraction}
                currentMatrix={currentMatrix}
                currentMatrixName={currentMatrixName}
                growthPeriod={growthPeriod}
                tabIndex={tabIndex}
                handleSelectTabIndex={handleSelectTabIndex}
            />
        </React.Fragment>
    );
}

AppControls.propTypes = {
    availableIndexes: PropTypes.any.isRequired,
    currentMatrix: PropTypes.any.isRequired,
    currentMatrixId: PropTypes.any.isRequired,
    matrixFiles: PropTypes.any.isRequired,
    growthPeriod: PropTypes.any.isRequired,
    zoom: PropTypes.any.isRequired,
    
    handleSelectMatrix: PropTypes.func.isRequired,
    handleSelectInflation: PropTypes.func.isRequired,
    handleShowReturns: PropTypes.func.isRequired,
    handleSelectTimeframe: PropTypes.func.isRequired,
    handleZoom: PropTypes.func.isRequired,
    handleTimeframeSubmit: PropTypes.func.isRequired,
};

export default AppControls;
